import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startTime", "endTime", "daypart"]

  connect() {
    console.log("AutoSubmit controller connected") 
  }
  
  timeChanged() {
    this.checkAndSubmit()
  }

  daypartChanged() {
    this.checkAndSubmit()
  }

  checkAndSubmit() {
    const startTime = this.startTimeTarget.value
    const endTime = this.endTimeTarget.value
    const selectedDaypart = document.querySelector('input[name="timeslot_daypart"]:checked')

    if (startTime && endTime && selectedDaypart) {
      this.element.requestSubmit()
    }
  }
}